import { render } from "./Formate.vue?vue&type=template&id=080226e3&scoped=true"
import script from "./Formate.vue?vue&type=script&lang=js"
export * from "./Formate.vue?vue&type=script&lang=js"

import "./Formate.vue?vue&type=style&index=0&id=080226e3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080226e3"]])

export default __exports__